import { AfterViewInit, Directive, ElementRef, Renderer2 } from '@angular/core';
import { UrlHelper } from '../../core/services/helpers/url-helper.service';

@Directive({
  selector: '[phoneCallable]'
})
export class PhoneCallableDirective implements AfterViewInit {
  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
    private urlHelper: UrlHelper
  ) {}

  ngAfterViewInit() {
    const div: HTMLElement = this.el.nativeElement;
    if (!this.urlHelper.isCallable) {
      const a = div.getElementsByClassName('anchor').item(0);
      if (a !== null) {
        this.renderer.setStyle(a, 'font-size', 'inherit');
        this.renderer.setStyle(a, 'text-decoration', 'none');
        this.renderer.setStyle(a, 'color', 'var(--ion-color-medium)');
        this.renderer.setStyle(a, 'cursor', 'default');
        a.removeAttribute('href');
      }
    }
  }
}
